import { render, staticRenderFns } from "./DragDropElement.vue?vue&type=template&id=b8399faa&scoped=true&"
import script from "./DragDropElement.vue?vue&type=script&lang=ts&"
export * from "./DragDropElement.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropElement.vue?vue&type=style&index=0&id=b8399faa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8399faa",
  null
  
)

export default component.exports